<template>
  <div>
    <div class="navbar">
      <v-icon v-if="$store.getters.isAuth" large class="ml-10" @click="$store.dispatch('sideNav')">{{icon}}</v-icon>
      <v-spacer></v-spacer>
      <div style="display:flex; align-items:center">
        <v-icon>mdi-flag</v-icon>
        <p class="mb-0">English</p>
        <img style="height:30px; width:auto;" class="mx-5" src="/img/notifications.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed:{
    icon(){
      if(!this.$store.state.sideNav){
        return 'mdi-menu'
      }else{
        return 'mdi-window-close'
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  height: 60px;

  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>